import { render, staticRenderFns } from "./TransView.vue?vue&type=template&id=9a873fa6&scoped=true&"
import script from "./TransView.vue?vue&type=script&lang=js&"
export * from "./TransView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a873fa6",
  null
  
)

export default component.exports